/**
 * Event Utilities
 * @description 이벤트 관리를 위한 유틸리티
 */

/**
 * Timeout 관리자
 * 아이템별 타임아웃 ID를 관리하여 중복 실행 방지
 */
export class TimeoutManager<K = unknown> {
  private timeouts = new Map<K, number>();

  set(key: K, callback: () => void, delay: number): void {
    this.clear(key);
    const timeoutId = window.setTimeout(callback, delay);
    this.timeouts.set(key, timeoutId);
  }

  clear(key: K): void {
    const timeoutId = this.timeouts.get(key);
    if (timeoutId !== undefined) {
      window.clearTimeout(timeoutId);
      this.timeouts.delete(key);
    }
  }

  has(key: K): boolean {
    return this.timeouts.has(key);
  }

  clearAll(): void {
    for (const timeoutId of this.timeouts.values()) {
      window.clearTimeout(timeoutId);
    }
    this.timeouts.clear();
  }
}

/**
 * DOM Ready 콜백
 */
export const onReady = (callback: () => void): void => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    callback();
  }
};
